import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import profileIcon from '@iconify/icons-ant-design/user';
import { UtilsLib } from '@payface-frontends-libs/utils';
import { MAvatar } from '../@material-extend/MAvatar';
const { createAvatar } = UtilsLib.Generics;
export function MyAvatar({ ...other }) {
    const user = JSON.parse(localStorage.getItem('@admin:user'));
    if (!user.profilePictures)
        return _jsx(Icon, { icon: profileIcon }, void 0);
    return (_jsx(MAvatar, Object.assign({ src: user.profilePictures.FACEBOX_FULL, alt: user.firstName, color: user.profilePictures ? 'default' : createAvatar(user.firstName).color }, other, { children: createAvatar(user.firstName).name }), void 0));
}
//# sourceMappingURL=MyAvatar.js.map